export default __webpack_public_path__ + "static/media/Personvernerklaring.1666b0ae.pdf";